import React from 'react';
import {openPrescriptionModal} from "../../redux/actions/modals";
import {useDispatch} from "react-redux";
import PrescriptionZoomComponent from "../dashboard/components/modals/PrescriptionZoomComponent";
import SafeCall from "../dashboard/components/modals/SafeCallModal";
import SafeCallComponent from "../dashboard/components/lab-orders/LabOrderItem/children/SafeCallComponent";
import { getVendorType } from '../../services/auth';

const OrderDetailsExpanded = (data) => {

    const order = {
        id: data.data.id
    }

    const dispatch = useDispatch();
    const checkForSafeCall = () => {
        const vendorType = getVendorType()

        return <SafeCallComponent order={order} />
      /*  if(vendorType === "DRUG" && data.data.status === "order_delivered") {
            const dateTimeOfUpdated = data.data.updated_at.split('.')[0]
            const dateOfUpdated = dateTimeOfUpdated.split('T')[0]
            const timeOfUpdated = dateTimeOfUpdated.split('T')[1]
            const updatedYear = dateOfUpdated.split('-')[0]
            const updatedMonths = dateOfUpdated.split('-')[1]
            const updatedDay = dateOfUpdated.split('-')[2]
            let today = new Date();
            if(updatedYear == today.getFullYear() && updatedMonths == (today.getMonth() + 1)) {
                if((today.getDate() - updatedDay < 2)) {
                    return <SafeCallComponent  order={data} />
                } else if(today.getDate() - updatedDay === 2) {
                    if(today.getHours() <= timeOfUpdated.split(":")[0]){
                        return <SafeCallComponent order={data} />
                    } 
                }
            }
        }*/
    }
    return(
        <div className="row orders-list" style={{padding: '10px', marginLeft:'0px', marginRight:'0px'}}>
            <div className="col-lg-3" style={{fontSize:'12px', textAlign:'right'}}>
                {data.data.customer_description}
            </div>
            <div className="col-lg-12 order-details">
                <div className="actions-holder">
                    <div className="prescriptions">
                        <div className="prescription-img-list row">
                            {
                                data.data.prescriptions.map((prescription, index) => {
                                    return (
                                        <div className="col-lg-3 col-md-3" style={{border:'1px dashed black', borderRadius:5,display:'flex',flexDirection:'column'}} key={prescription.id}>
                                            <div className="prescription-img">
                                                <img src={prescription.url} id={"prescription-" + index} alt=""
                                                     style={{width: '100%', maxHeight: '150px'}}/>
                                            </div>
                                            <div className="prescription-actions">
                                                {
                                                    prescription.file.id !== 3249298 ?
                                                        <>
                                                            <a className="btn btn-success btn-sm" onClick={() => {
                                                                dispatch(openPrescriptionModal(prescription.url));
                                                            }}
                                                            >مشاهده</a>
                                                            <button className="btn btn-warning btn-sm" onClick={() => {
                                                                let popup = window.open();
                                                                popup.document.write("<img src=\"" + prescription.url + "\" alt='' />");
                                                                popup.focus(); //required for IE
                                                                popup.print();
                                                            }}>
                                                                چاپ
                                                            </button>
                                                        </>
                                                        : null
                                                }
                                            </div>
                                            {
                                                prescription.description ?
                                                    <div style={{textAlign:'justify'}}> توضیحات نسخه  : {prescription.description}</div>
                                                    : <div>توضیحاتی ندارد</div>
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="flex-row">
                            {checkForSafeCall()}
                        </div>
                    </div>
                </div>
            </div>
            <PrescriptionZoomComponent />
            <SafeCall order={order} />
        </div>
    )
}
export default OrderDetailsExpanded;
